<template>
  <div style="height: 100%">
    <el-row>
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        空间：
      </el-col>
      <el-col :lg="20" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <el-row>
          <el-col :lg="8" :md="10" :sm="15" :xl="8" :xs="24" style="margin-top: 5px;">
            <el-cascader
              :disabled="form.allSpaceChecked"
              :options="spaceTree"
              @change="changeSpace"
              change-on-select="true"
              clearable
              placeholder="请选择空间"
              size="mini"
              style="width: 95%"
              v-model="form.spaceId">
            </el-cascader>
          </el-col>
          <el-col :lg="10" :md="7" :sm="8" :xl="10" :xs="24" style="margin-top: 5px;">
            <el-checkbox @change="changeCheckbox" v-model="form.allSpaceChecked">全部空间</el-checkbox>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="margin-top-20">
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        设备：
      </el-col>
      <el-col :lg="18" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="24">
          <el-select
            @change="changeCategory"
            placeholder="请选择设备分类"
            size="mini"
            style="width: 95%;"
            v-model="form.deviceCategoryId">
            <el-option
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
              v-for="item in categoryList">
            </el-option>
          </el-select>
        </el-col>
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="24">
          <el-select
            @change="changeDevice"
            placeholder="可选择设备"
            size="mini"
            style="width: 95%;"
            v-model="form.deviceId">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in deviceList">
            </el-option>
          </el-select>
        </el-col>
        <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="24">
          <el-select
            placeholder="可选择测点"
            size="mini"
            style="width: 95%;"
            v-model="form.devicePoint">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in pointList">
            </el-option>
          </el-select>
        </el-col>
      </el-col>
    </el-row>
    <el-row class="margin-top-20">
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        策略详情：
      </el-col>
      <el-col :lg="18" :md="19" :offset="1" :sm="18" :xl="18" :xs="18" style="max-height: 40vh;overflow-y: auto">
        <strategy-detail
          :accountList="accountList"
          :alarmUpgradeAction='form.alarmUpgradeActionList'
          :index="index"
          :key="index"
          @add="add"
          @deleteIndex="del"
          @uploadData="getData"
          v-for="(item,index) in form.alarmUpgradeActionList"
        >
        </strategy-detail>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import StrategyDetail from "@/views/basic_operations/strategy/alarm_upgrade/StrategyDetail";
import {getDeviceCategoryList} from "@/network/device-category";
import {getBySpaceIdAndTypId} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";
import lodash from "lodash";

export default {
  name: "UpgradeStrategy",
  components: {StrategyDetail},
  data() {
    return {
      categoryList: [],
      deviceList: [],
      pointList: [],
      form: {
        spaceId: '',
        allSpaceChecked: false,
        deviceCategoryId: '',
        deviceId: '',
        devicePoint: '',
        alarmUpgradeActionList: [],
      },
      categoryId: null,
    }
  },
  props: ["spaceTree", "strategyData", "accountList"],
  watch: {
    form: {
      handler(newV) {
        this.$emit('receiveData', newV)
      },
      deep: true
    },
    strategyData: {
      handler(val) {
        this.deviceList = []
        this.pointList = []
        if (val !== undefined && val.id) {
          this.init();
        } else {
          this.form = {
            spaceId: '',
            allSpaceChecked: false,
            deviceCategoryId: '',
            deviceId: '',
            devicePoint: '',
            alarmUpgradeActionList: [],
          }
          this.add();
        }
      },
      deep: true
    },
    spaceTree(newVal) {
      this.spaceTree = newVal;
    },
  },
  created() {
    if (this.strategyData !== undefined && this.strategyData.id) {
      this.init();
    } else {
      this.add();
    }
    this.getDeviceCategoryList();
  },
  methods: {
    //初始化
    init() {
      this.form = lodash.cloneDeep(this.strategyData);
      if (this.form.spaceId === '0') {
        this.form.allSpaceChecked = true;
      } else {
        this.form.allSpaceChecked = false;
      }
      if (this.form.deviceCategoryId !== '0') {
        this.getDevice(null, this.form.deviceCategoryId);
        this.getPoint(this.form.deviceId);
      }
      if (this.form.deviceId === "0") {
        this.form.deviceId = null;
      }
      if (this.form.devicePoint === "0") {
        this.form.devicePoint = null;
      }
    },
    //新增一条策略
    add() {
      let alarmUpgradeAction = {
        startTime: null,
        intervalTime: null,
        time: null,
        noticeAccountIds: [],
        accountNames: [],
        notifyTypeCodes: [],
        notifyNames: [],
      }
      this.form.alarmUpgradeActionList.push(alarmUpgradeAction);
    },
    //删除一条策略
    del(index) {
      this.form.alarmUpgradeActionList.splice(index, 1)
    },
    //获取设备类型列表
    getDeviceCategoryList() {
      this.categoryList = [];
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.categoryList.push({id: '0', cnName: '全部'})
            res.data.forEach(item => {
              this.categoryList.push(item)
            })
          }
        }
      })
    },
    //根据设备类型标识获取权限设备
    getDeviceList() {
      this.deviceList = []
      this.form.deviceId = null
      this.pointList = []
      this.form.devicePoint = null
      let spaceId = 0;
      let categoryId = 0;
      if (this.form.allSpaceChecked || typeof this.form.spaceId === 'string') {
        spaceId = null
      }
      if (this.form.spaceId !== undefined && typeof this.form.spaceId !== 'string' && !this.form.allSpaceChecked) {
        spaceId = this.form.spaceId[this.form.spaceId.length - 1];
      }
      if (this.categoryId) {
        categoryId = this.categoryId;
      }
      this.getDevice(spaceId, categoryId);
    },
    getDevice(spaceId, categoryId) {
      getBySpaceIdAndTypId(spaceId, categoryId).then(res => {
        if (res.code === 0) {
          this.deviceList = res.data;
        }
      })
    },
    //根据设备标识获取设备测点
    getPointList(deviceId) {
      this.pointList = []
      this.form.devicePoint = null
      this.getPoint(deviceId);
    },
    getPoint(deviceId) {
      listByDeviceId(deviceId).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              this.pointList.push(item)
            })
          }
        }
      })
    },
    //空间选择
    changeSpace() {
      this.getDeviceList();
    },
    //勾选框选择
    changeCheckbox() {
      this.getDevice(this.form.spaceId, this.form.deviceCategoryId);
    },
    //设备类型选择
    changeCategory(id) {
      this.categoryId = id
      this.getDeviceList();
    },
    //设备选择
    changeDevice(id) {
      this.getPointList(id)
    },
    //获取策略详情数据
    getData: function (val) {
      let index = val.index;
      this.form.alarmUpgradeActionList[index] = val.data
    },
  }
}
</script>

<style scoped>

</style>
